import React, { Component } from 'react'
import {reduxForm, Field, Fields} from 'redux-form'
import { Link } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import InputCheckBox from '../comun/form/InputCheckBox'
import InputSelect from '../comun/form/InputSelect'
import InputRangeDatePickerDynamicNames from '../comun/form/InputRangeDatePickerDynamicNames'
import { Delete, Launch, Print, FilterList, AddCircleOutline } from '@material-ui/icons'
import {date_formatter, dateTimeZones, date_parser} from '../../util/formatFunctions'
import { verracoSiNo } from '../../constants/seguimiento'
import {permisos as permisosConstant} from '../../constants/permisos'

class FiltrosSeguimiento extends Component {
  constructor () {
    super()
    this.state = {
      openFiltros: false,
      imputSelected: false,
      tipo: 1,
      fitrosSeleccionados: [],
      quitarFiltroFechas: false
    }
    this.fetchSeguimientos = this.fetchSeguimientos.bind(this)
    this.crearCsvSeguimiento = this.crearCsvSeguimiento.bind(this)
    this.imprimirPdfSeguimiento = this.imprimirPdfSeguimiento.bind(this)
  }

  componentDidMount () {
    this.props.actions.comboVerraco()
    this.props.actions.fetchComboPool()
    this.props.actions.comboRaza()
    this.props.actions.comboLineaGenetica()
    this.props.actions.comboNivelGenetico()
    // this.props.change('tipo', {value: 1, label: this.props.t('COMUN.COMBOS.VERRACO_POOL.VERRACO')})
    this.props.initialize({
      fechaDesde: date_parser(dateTimeZones(this.props.auth.zonaHorariaString), this.props.auth.formaFechaHora),
      /*tipo: {value: 1, label: this.props.t('COMUN.COMBOS.VERRACO_POOL.VERRACO')}*/
    })
  }

  componentDidUpdate (prevProps) {
    if (this.props.seguimientoTable && Object.keys(this.props.seguimientoTable).length > 0) {
      if (this.props.seguimientoTable !== prevProps.seguimientoTable) {
        let contActivos = 0
        if (this.props.seguimientoTable.values) {
          Object.values(this.props.seguimientoTable.values).forEach((value) => {
            if (value === true) {
              contActivos++
            }
          })
          if (contActivos === 0) {
            this.props.change('seleccionar-todos-modal-seguimiento', false)
            this.setState({ imputSelected: false })
            this.props.actions.deSeleccionarTodosSeguimiento()
          }
        }
      }
    }
    if (this.props.filtros !== prevProps.filtros) {    
      this.setState({quitarFiltroFechas: false})
    }
  }

  fetchSeguimientos(values){
    this.props.actions.fetchSeguimientos(values)
  }

  abrirFiltros = (event) => {
    this.setState({ openFiltros: true })
  }

  cerrarFiltros = (event) => {
    this.setState({ openFiltros: false })
  }

  intercambiarCheck = (value) => {
    this.setState({ imputSelected: value })
    if (value === true) {
      this.props.actions.seleccionarTodosSeguimiento()
    } else {
      this.props.actions.deSeleccionarTodosSeguimiento()
    }
  }

  deleteSeleccionSeguimiento(){
    const itemsSeleccion = this.props.mainList.map((row) => {
      return this.props[this.props.idForm].values['check' + this.props.idForm + row[this.props.idElemento]] === true && (
        {
          'check': this.props[this.props.idForm].values['check' + this.props.idForm + row[this.props.idElemento]],
          [this.props.idElemento]: row[this.props.idElemento]
        }
      )
    })
    let list = itemsSeleccion.filter(function (item) {
      return item.check === true;
    });
    this.props.actions.deleteSeleccionSeguimiento(list)
  }

  crearCsvSeguimiento(){
    this.props.actions.crearCsvSeguimiento(this.props.filtros)
  }

  imprimirPdfSeguimiento(){
    this.props.actions.imprimirPdfSeguimiento(this.props.filtros)
  }

  abrirModalNuevoSeguimiento(){
    this.props.actions.abrirModalNuevoSeguimiento()
    //this.props.actions.fetchFiltrarModalInicio({periodo: {value: 60}, fecha: date_parser(dateTimeZones(this.props.auth.zonaHorariaString), this.props.auth.formaFechaHora)})
  }

  quitarFiltros (value) {
    let values = this.props.filtros
    if (value == 'fechaDesde' || value == 'fechaHasta') {        
      let ultimoMes = new Date()      
      ultimoMes.setMonth(ultimoMes.getMonth() - 1)
      values['fechaDesde'] = date_parser(ultimoMes, this.props.auth.formaFechaHora)
      values['fechaHasta'] = null 
      values['desde'] = date_parser(ultimoMes, this.props.auth.formaFechaHora)
      values['hasta'] = null     
      this.props.actions.fetchSeguimientos(values)
      this.props.change('fechaDesde', ultimoMes)  
      this.props.change('fechaHasta', null)   
      this.props.change('desde', ultimoMes)  
      this.props.change('hasta', null)     
      this.setState({quitarFiltroFechas: true})
    } else {
      values[value] = null
      this.props.actions.fetchSeguimientos(values)
      this.props.change(value, null)
    }
    this.setState({fitrosSeleccionados: values})
  }

  render () {
    const {
      t, handleSubmit, auth: { formaFechaHora }, filtros = {},
      combos: { comboPool, comboVerraco, comboLineaGenetica, comboRaza, comboNivelGenetico }
    } = this.props
    const tKey = 'SEGUIMIENTO.'

    let comboVerracoSiNo = this.props.combos.comboVerracoSiNo
    comboVerracoSiNo = comboVerracoSiNo.map((verracoSiNoItem) => {
      return {...verracoSiNoItem, label: t(`COMUN.COMBOS.${verracoSiNoItem.label}`)}
    })

    let comboTipoControlSeguimiento = this.props.combos.comboTipoControlSeguimiento
    comboTipoControlSeguimiento = comboTipoControlSeguimiento.map((tipoControlSeguimientoItem) => {
      return {...tipoControlSeguimientoItem, label: t(`COMUN.COMBOS.${tipoControlSeguimientoItem.label}`)}
    })

    return (
      <div>
        <div className={this.state.openFiltros === true ? 'tabla-filtros open-filters' : 'tabla-filtros'}>
          <form className="custom-form">
            <Field
              colSm={2}
              id="tipo"
              name="tipo"
              controlLabel={t(tKey + 'FILTROS.VERRACO_POOL_SI_NO')}
              component={InputSelect}
              options={comboVerracoSiNo}
              //isClearable={false}
              valueKey="value"
              labelKey="label"
              /*onInputChange={(tipo) => {
                this.setState({tipo: tipo ? tipo.value : null})
                if (tipo && tipo.value === verracoSiNo.POOL) {
                  this.quitarFiltros('verraco')
                } else if (tipo && tipo.value === verracoSiNo.VERRACO) {
                  this.quitarFiltros('pool')
                }
                handleSubmit(this.fetchSeguimientos)(tipo)
              }}*/
              onInputChange={handleSubmit(this.fetchSeguimientos)}
            />
            {(!this.state.tipo || this.state.tipo === verracoSiNo.POOL) && (
              <Field
                colSm={2}
                id="pool"
                name="pool"
                controlLabel={t(tKey + 'FILTROS.POOL')}
                component={InputSelect}
                options={comboPool}
                valueKey="value"
                labelKey="label"
                onInputChange={handleSubmit(this.fetchSeguimientos)}
              />
            )}
            {(!this.state.tipo || this.state.tipo === verracoSiNo.VERRACO) && (
              <Field
                colSm={2}
                id="verraco"
                name="verraco"
                controlLabel={t(tKey + 'FILTROS.VERRACO')}
                component={InputSelect}
                options={comboVerraco}
                valueKey="value"
                labelKey="label"
                onInputChange={handleSubmit(this.fetchSeguimientos)}
              />
            )}
            <Field
              colSm={2}
              id="raza"
              name="raza"
              controlLabel={t(tKey + 'FILTROS.RAZA')}
              component={InputSelect}
              options={comboRaza}
              valueKey="value"
              labelKey="label"
              onInputChange={handleSubmit(this.fetchSeguimientos)}
            />
            <Field
              colSm={2}
              id="linea"
              name="linea"
              controlLabel={t(tKey + 'FILTROS.LINEA_GENETICA')}
              component={InputSelect}
              options={comboLineaGenetica}
              valueKey="value"
              labelKey="label"
              onInputChange={handleSubmit(this.fetchSeguimientos)}
            />
            <Field
                colSm={2}
                id="nivelGenetico"
                name="nivelGenetico"
                controlLabel={t('PLANING.FILTROS.NIVEL_GENETICO')}
                component={InputSelect}
                options={comboNivelGenetico}
                valueKey="value"
                labelKey="label"
                customClass='nombre-operario'
                onInputChange={handleSubmit(this.fetchSeguimientos)}
              />
            <Field
              colSm={2}
              id="tipoControl"
              name="tipoControl"
              controlLabel={t(tKey + 'FILTROS.TIPO_CONTROL')}
              component={InputSelect}
              options={comboTipoControlSeguimiento}
              valueKey="value"
              labelKey="label"
              noPredeterminado={false}
              onInputChange={handleSubmit(this.fetchSeguimientos)}
            />
            <Fields
              names={['fechaDesde', 'fechaHasta']}
              component={InputRangeDatePickerDynamicNames}
              colSm={4}
              nameFrom="fechaDesde"
              nameTo="fechaHasta"
              controlLabel={t(tKey + 'FILTROS.PERIODO')}
              onInputChange={handleSubmit(this.fetchSeguimientos)}
            />
            <div className="aplicar-tabla-filtros">
              <div className="filtros-anadidos">
                {
                  Object.keys(filtros).length > 0 && [
                    (filtros.tipo && <span key="filtros.tipo" className="badge-dark">{t(tKey + 'FILTROS.VERRACO_POOL_SI_NO') + ': ' + filtros.tipo.label}</span>),
                    (filtros.pool && <span key="filtros.pool" className="badge-dark">{t(tKey + 'FILTROS.POOL') + ': ' + filtros.pool.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('pool')}> x </button></span>),
                    (filtros.verraco && <span key="filtros.verraco" className="badge-dark">{t(tKey + 'FILTROS.VERRACO') + ': ' + filtros.verraco.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('verraco')}> x </button></span>),
                    (filtros.linea && <span key="filtros.linea"  className="badge-dark">{t(tKey + 'FILTROS.LINEA_GENETICA') + ': ' + filtros.linea.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('linea')}> x </button></span>),
                    (filtros.nivelGenetico && <span key="filtros.nivelGenetico"  className="badge-dark">{t(tKey + 'FILTROS.NIVEL_GENETICO') + ': ' + filtros.nivelGenetico.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('nivelGenetico')}> x </button></span>),
                    (filtros.raza && <span key="filtros.raza" className="badge-dark">{t(tKey + 'FILTROS.RAZA') + ': ' + filtros.raza.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('raza')}> x </button></span>),
                    (filtros.tipoControl && <span key="filtros.tipoControl" className="badge-dark">{t(tKey + 'FILTROS.TIPO_CONTROL') + ': ' + filtros.tipoControl.label}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('tipoControl')}> x </button></span>),
                    (filtros.fechaDesde && filtros.fechaHasta && filtros.fechaDesde !== null && filtros.fechaHasta !== null) ? (
                      <span key="filtros.fechaDesdeHasta" className="badge-dark">{t(tKey + 'FILTROS.PERIODO') + ' ' + t('COMUN.DATE.DESDE') + ': ' + date_formatter(filtros.fechaDesde, this.props.auth.formaFechaHora, false) + ' - ' + t('COMUN.DATE.HASTA') + ': ' + date_formatter(filtros.fechaHasta, this.props.auth.formaFechaHora, false)}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('fechaHasta')}> x </button></span>
                    ) : (filtros.fechaDesde && filtros.fechaDesde !== null) ? (
                      <span key="filtros.fechaDesde" className="badge-dark">{t(tKey + 'FILTROS.PERIODO') + ' ' + t('COMUN.DATE.DESDE') + ': ' + date_formatter(filtros.fechaDesde, this.props.auth.formaFechaHora, false)}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('fechaDesde')}> x </button></span>
                    ) : (filtros.fechaHasta && filtros.fechaHasta !== null) && (
                      <span key="filtros.fechaHasta" className="badge-dark">{t(tKey + 'FILTROS.PERIODO') + ' ' + t('COMUN.DATE.HASTA') + ': ' + date_formatter(filtros.fechaHasta, this.props.auth.formaFechaHora, false)}<button type="button" className="quitar-filtro" onClick={() => this.quitarFiltros('fechaHasta')}> x </button></span>
                    )
                  ]
                }
                {(this.state.quitarFiltroFechas === true && <span> {t('ANALISIS_EXTRACCIONES.FILTROS.AVISO_FILTROS_CERRADOS')}</span>)}
              </div>
            </div>
          </form>
        </div>
        <Row className="acciones-tabla-filtros">
          <Col sm={10}>
            <div className="buttons-flex">
              {(this.props.auth.permisos === '-1' || this.props.auth.permisos[permisosConstant.SEGUIMIENTO] > 1) && [
                <div className="custom-check-w" key="custom-check-w">
                  <Field
                    id="seleccionar-todos-modal-seguimiento"
                    name="seleccionar-todos-modal-seguimiento"
                    colSm={12}
                    inline
                    component={InputCheckBox}
                    onInputChange={(value) => this.intercambiarCheck(value)}
                  />
                </div>,
                <div id="block-options" key="block-options" className={this.state.imputSelected === true ? 'button-group buttons-min block-options' : 'button-group buttons-min block-options oculta-action'}>
                  <button type="button" className="btn btn-icono" onClick={(e) => this.deleteSeleccionSeguimiento()}>
                    <Delete></Delete> {t(tKey + 'FILTROS.ELIMINAR')}
                  </button>
                  <div className="barra-buttons-min"></div>
                </div>
              ]}
              <div className="button-group buttons-min">
                <button type="button" className="btn btn-icono" onClick={(e) => this.crearCsvSeguimiento()}>
                  <Launch></Launch> {t(tKey + 'FILTROS.EXPORTAR')}
                </button>
                <button type="button" className="btn btn-icono" onClick={(e) => this.imprimirPdfSeguimiento()}>
                  <Print></Print> {t(tKey + 'FILTROS.IMPRIMIR')}
                </button>
                { (this.props.auth.version && this.props.auth.version >= 2) &&
                    <button type="button" className="btn btn-primary nuevo" onClick={(e) => this.abrirModalNuevoSeguimiento()}>
                      <AddCircleOutline></AddCircleOutline> {t(tKey + 'FILTROS.NUEVO')}
                    </button>
                  }
              </div>
            </div>
          </Col>
          <Col sm={2} className="content-button-filtro">
            <div className="button-group buttons-min button-filtro">
              <div className={this.state.openFiltros === true ? 'btn filters-desp opener-open' : 'btn filters-desp'} onClick={(e) => this.state.openFiltros === false ? this.abrirFiltros() : this.cerrarFiltros()}>
                <FilterList></FilterList> {t(tKey + 'FILTROS.ABRIR_FILTROS')}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default (reduxForm({
  form: 'FiltrosSeguimiento',
  initialValues: {
    fechaDesde: new Date()
  }
})(FiltrosSeguimiento))
